import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SarContacts } from '@navfleet/client/map/safety/domain/models';
import { environment } from '@navfleet/shared/core/environment';
import { Observable } from 'rxjs';

const SAR_URL = `${environment.NAVFLEET_BACKEND}/api/v1/data-layers/sar-contacts`;

@Injectable({
    providedIn: 'root',
})
export class MapSafetySarApi {
    private readonly http = inject(HttpClient);

    public get(): Observable<SarContacts> {
        return this.http.get<SarContacts>(SAR_URL);
    }
}
